import { api } from './api';
import { 
  ManageUserUpdateRequest, 
  ManageUserStatusRequest,
  ManageUserBillingTypeRequest,
  PaginatedResponse 
} from '../types/manageUsers';

export const manageUsersService = {
  async fetchUsers(page: number = 0, size: number = 10, search: string = ''): Promise<any> {
    const res = await api.get('/admin/manage-users', {
      params: { page, size, search }
    });
    return res.data;
  },

  async fetchUserDetail(userId: string | number): Promise<any> {
    const res = await api.get(`/admin/manage-users/${userId}`);
    return res.data;
  },

  async updateUser(userId: string | number, payload: ManageUserUpdateRequest): Promise<any> {
    const res = await api.put(`/admin/manage-users/${userId}`, payload);
    return res.data;
  },

  async updateUserStatus(userId: string | number, payload: ManageUserStatusRequest): Promise<any> {
    const res = await api.patch(`/admin/manage-users/${userId}/status`, payload);
    return res.data;
  },

  async updateUserBillingType(userId: string | number, payload: ManageUserBillingTypeRequest): Promise<any> {
    const res = await api.patch(`/admin/manage-users/${userId}/billing-type`, payload);
    return res.data;
  },

  async fetchUserDocuments(userId: string | number): Promise<any> {
    const res = await api.get(`/admin/manage-users/${userId}/documents`);
    return res.data;
  },

  async fetchBasicUserList(search: string = ''): Promise<any> {
    const res = await api.get('/admin/users/basic-list', {
      params: { search }
    });
    return res.data;
  }
};
